import { BaseService } from './base.service';

export class KktService extends BaseService {
    baseUrl = '/kkt';
}
